<template>
  <div class="content">
    <div class="top">
      <div class="ellipsis">
        <div>{{ vehicleType }}</div>
        <img
          :src="require('../assets/img/ellipsis.png')"
          alt=""
          @click="toHistory"
        />
      </div>
      <div class="vin">{{ vin }}</div>
    </div>
    <div>
      <van-tabs v-model:active="active" shrink>
        <van-tab class="myCard" title="我的卡">
          <CardItem
            v-for="(item, index) in myCardList"
            :key="index"
            :cardItem="item"
          />
          <div style="height: 0.01px"></div>
        </van-tab>
        <van-tab title="购买包月卡">
          <div class="saleCard">
            <SaleCard
              v-for="(item, index) in buyCardList"
              :key="index"
              :cardItem="item"
              @click="clickSaleCard(index)"
              :select="selectIndex === index"
            />
            <div style="height: 0.01px"></div>
          </div>
          <div class="bottom">
            <van-checkbox v-model="checked" icon-size="4.27vw" class="radio"
              ><span
                >我已阅读并同意<span
                  style="color: rgba(0, 123, 254, 1)"
                  @click.stop="servicePage"
                  >《捷能智电电卡服务合同》</span
                ></span
              ></van-checkbox
            >
            <div class="buyButton" @click="toBuy">去支付</div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script setup>
import { showToast, Tab as vanTab, Tabs as vanTabs } from "vant";
import { Checkbox as vanCheckbox } from "vant";
import { useRoute, useRouter } from "vue-router";
import { ref } from "vue";
import CardItem from "@/views/cpCompany/monthlyCard/components/CardItem.vue";
import {
  checkCanBuy,
  getCpCardList,
  getCpCardListByVin,
} from "@/views/cpCompany/api";
import SaleCard from "@/views/cpCompany/monthlyCard/components/SaleCard.vue";
const $route = useRoute();
const $router = useRouter();
const checked = ref("");
//接受值
const vin = ref($route.query.vin);
const vehicleType = ref($route.query.vehicleType);
const active = ref(0);
// 获取我的卡
const myCardList = ref([]);
const getCardList = async () => {
  const res = await getCpCardList(vin.value);
  myCardList.value = res.data.data.contentList;
};
getCardList();
// 获取可购买卡
const buyCardList = ref([]);
const getBuyCardList = async () => {
  const res = await getCpCardListByVin(vin.value);
  const tempData = res.data.data;
  const category_1 = tempData.filter((item) => item.category === 1);
  const category_2 = tempData.filter((item) => item.category === 2);
  buyCardList.value = [...category_1, ...category_2];
};
getBuyCardList();
const toBuy = async () => {
  if (checked.value) {
    if (selectIndex.value === -1) {
      showToast("请选择包月卡");
    } else {
      const itemData = buyCardList.value[selectIndex.value];
      // 检测是否允许下单
      const res = await checkCanBuy({
        cardPackId: itemData.id,
        vin: vin.value,
      });
      if (!res.data.success) {
        showToast(res.data.message);
        return;
      }
      // 允许下单的逻辑
      // eslint-disable-next-line no-unreachable
      await $router.push({
        path: "/cpCompany/payPage",
        query: {
          userId: $route.query.userId,
          cardPackId: itemData.id,
          userPhone: $route.query.userPhone,
          plate: $route.query.plate,
          vin: vin.value,
          price: itemData.sellingPrice,
        },
      });
    }
  } else {
    showToast("请仔细阅读《捷能智电电卡服务合同》并勾选同意");
  }
};
// 选中包月卡
const selectIndex = ref(-1);
const clickSaleCard = (index) => {
  selectIndex.value = index;
};
const servicePage = () => {
  $router.push({
    name: "serviceContract",
  });
};
// 查看购买记录
const toHistory = () => {
  $router.push({
    path: "/cpCompany/purchaseRecords",
    query: {
      userPhone: $route.query.userPhone,
    },
  });
};
</script>

<style scoped lang="scss">
.content {
  background-image: url("../assets/img/topImg.png");
  background-size: 100%;
  background-repeat: no-repeat;
}
.top {
  .ellipsis {
    padding: 4.27vmin 5.33vmin 3.2vmin 5.87vmin;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    font-size: 6.4vmin;
    color: #10275b;
    line-height: 8.8vmin;
    img {
      width: 5.33vmin;
      height: 5.33vmin;
    }
  }
  .vin {
    padding-left: 5.87vmin;
    font-weight: 400;
    font-size: 3.2vmin;
    color: #8793ad;
    line-height: 4.53vmin;
    margin-bottom: 3.73vmin;
  }
}
:deep(.van-tabs__wrap) {
  border-radius: 5.33vmin 5.33vmin 0 0;
  padding-bottom: 5.33vmin;
  background-color: white;
}
:deep(.van-tabs__nav) {
  border-radius: 5.33vmin 5.33vmin 0 0;
  padding-left: 3.2vmin;
}
.myCard {
  background-color: white;
  max-height: calc(100vh - 50vmin);
  overflow-y: scroll;
}
.saleCard {
  box-sizing: border-box;
  max-height: calc(100vh - 50vmin);
  overflow-y: scroll;
  padding-left: 5.87vmin;
  background-color: white;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding-bottom: 40.67vmin;
}
.radio {
  display: flex;
  justify-content: center;
  margin-bottom: 4.27vmin;
  margin-top: 3vmin;
  span {
    font-weight: 400;
    font-size: 3.2vmin;
    color: rgba(16, 39, 91, 0.5);
    line-height: 4.53vmin;
  }
}
.buyButton {
  width: 84vmin;
  line-height: 11.73vmin;
  background: #007bfe;
  border-radius: 5.87vmin;
  font-weight: 400;
  font-size: 4.27vmin;
  color: #ffffff;
  text-align: center;
  margin: 0 auto;
}
.bottom {
  position: fixed;
  bottom: 0;
  width: 100vmin;
  background-color: white;
  padding-bottom: 9.07vmin;
}
</style>
